// #927 — single-source admin vocabulary pin.
//
// Before this file existed, the same engagement signal was labeled
// four different ways across the admin UI ("Card weight", "Topic
// weight", "Engagement score", "Interest gauge"). Picking ONE term
// here and importing it at every call site makes drift detectable:
// a future tweak that wants to re-introduce a synonym has to either
// edit this file (explicit, visible in PR review) or hard-code a
// string that the `labels.test.js` string-scan will fail on.
//
// Backend field names (`card_weights.weight`, `engagement_score`,
// `user_activity_preferences.topic_weight`) intentionally stay as
// they are — this pin is UI-only.

export const ENGAGEMENT_LABEL = 'Engagement';
